import { Cdn } from 'utils/assets'

const PRIVACY_POLICY_PDF =
  'https://www.arvore.com.br/arvore-politica-de-privacidade-completo'
const TERMS_OF_USE_PDF = Cdn.getAssetUrl('Termo+de+uso+A%CC%81rvore.pdf')

const INSTITUTIONAL_INFO =
  'Árvore Livros Comércio Distribuição e Serviços SA - CNPJ 19.004.863/0001-65 - Rua Sacadura Cabral 144 - Rio de Janeiro - RJ'

export { INSTITUTIONAL_INFO, PRIVACY_POLICY_PDF, TERMS_OF_USE_PDF }

export const maxInstallments = 10
